module.exports = __webpack_public_path__ + "static/media/memory_2.1ebed42c.png";